import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

const ITEMS = [
  'ISO 22000',
  'HACCP',
  'GDPR Ready',
  'SOC 2 Architecture',
  'OPC-UA Scales',
  'EU 853/2004',
  'Traceability Stack',
  'Audit Export · PDF/CSV',
];

export default function LogosMarquee() {
  const { t } = useLanguage();
  const items = [...ITEMS, ...ITEMS];

  return (
    <section
      aria-label={t.logos?.aria || 'Industry standards and integrations'}
      className="bg-white border-b border-ct-line"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row md:items-center gap-6">
          <div className="md:w-56 flex-shrink-0">
            <p className="text-[11px] font-bold uppercase tracking-widest text-ct-ink-3">
              {t.logos?.label || 'Ready for the standards your auditors care about'}
            </p>
          </div>
          <div className="relative flex-1 overflow-hidden ct-marquee-pause-hover">
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent z-10"
            />
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent z-10"
            />
            <ul className="ct-marquee-track gap-10">
              {items.map((label, i) => (
                <li
                  key={`${label}-${i}`}
                  className="flex items-center gap-2 text-sm font-semibold text-ct-ink-2 whitespace-nowrap"
                >
                  <span
                    aria-hidden="true"
                    className="inline-block w-1.5 h-1.5 bg-ct-brand"
                  />
                  <span
                    className="font-mono uppercase tracking-wider text-[13px]"
                    style={{ fontFamily: 'IBM Plex Mono, monospace' }}
                  >
                    {label}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
